import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { Gift } from '../components/gift';
import { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import { Contacts } from '../components/contacts';

export default class GiftsPage extends React.Component {
  render() {
    const { data } = this.props;
    const {
      html,
      frontmatter: { title },
    } = data.markdownRemark;

    const collections = [
      {
        title: 'Букеты из живых цветов',
        items: data.fresh.edges,
      },
      {
        title: 'Сухоцветные букеты',
        items: data.dry.edges,
      },
      {
        title: 'Цветочные композиции',
        items: data.compositions.edges,
      },
      {
        title: 'Скидки',
        items: data.discount.edges,
      },
    ];

    return (
      <Layout title={title}>
        <section className="section">
          <div className="container">
            <h1 className="title is-1 has-text-centered">{title}</h1>
            {collections.map(({ title, items }) => {
              return (
                <div key={title}>
                  <h2 className="title is-2 has-text-centered">{title}</h2>
                  <div className="columns is-multiline">
                    {items.map(({ node }) => (
                      <div className="column is-one-third" key={node.id}>
                        <Gift
                          title={node.frontmatter.title}
                          description={node.frontmatter.description}
                          price={node.frontmatter.price}
                          discount_price={node.frontmatter.discount_price}
                          image={node.frontmatter.image}
                          slug={node.fields.slug}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
            <hr />
            <HTMLContent className="content" content={html} />
            <h4 className="title is-4">
              Для заказа нецветочного подарка оставь свои контакты в форме ниже или свяжись со мной
              любым удобным образом.
            </h4>
            <hr />
            <div className="columns">
              <div className="column">
                <Contacts />
              </div>
              <div className="column">
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

GiftsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export const pageQuery = graphql`
  query GiftsQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }

    fresh: allMarkdownRemark(
      filter: {
        frontmatter: {
          type: { eq: "gift" }
          is_hidden_from_list: { ne: true }
          tags: { in: ["fresh"] }
        }
      }
      sort: { fields: [frontmatter___sort_order] }
    ) {
      edges {
        node {
          ...GiftForShowcase
        }
      }
    }

    dry: allMarkdownRemark(
      filter: {
        frontmatter: {
          type: { eq: "gift" }
          is_hidden_from_list: { ne: true }
          tags: { in: ["dry"] }
        }
      }
      sort: { fields: [frontmatter___sort_order] }
    ) {
      edges {
        node {
          ...GiftForShowcase
        }
      }
    }

    compositions: allMarkdownRemark(
      filter: {
        frontmatter: {
          type: { eq: "gift" }
          is_hidden_from_list: { ne: true }
          tags: { in: ["composition"] }
        }
      }
      sort: { fields: [frontmatter___sort_order] }
    ) {
      edges {
        node {
          ...GiftForShowcase
        }
      }
    }

    discount: allMarkdownRemark(
      filter: {
        frontmatter: {
          type: { eq: "gift" }
          is_hidden_from_list: { ne: true }
          discount_price: { ne: null }
        }
      }
      sort: { fields: [frontmatter___sort_order] }
    ) {
      edges {
        node {
          ...GiftForShowcase
        }
      }
    }
  }
`;
